import React, { useState } from 'react';
import { css, keyframes } from '@emotion/css';
import { FaWhatsapp } from 'react-icons/fa';

export interface WhatsAppButtonProps extends React.HTMLAttributes<HTMLDivElement> {}

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const button = css({
  width: '60px',
  height: '60px',
  backgroundColor: '#25D366',
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
  cursor: 'pointer',
  transition: 'transform 0.3s, box-shadow 0.3s',
  border: 'none',
  position: 'relative',
  '&:hover': {
    transform: 'scale(1.05)',
    boxShadow: '0 6px 16px rgba(0, 0, 0, 0.25)',
  },
  '@media (max-width: 768px)': {
    width: '50px',
    height: '50px',
  },
  '@media (max-width: 480px)': {
    width: '45px',
    height: '45px',
  },
});

const icon = css({
  color: 'white',
  fontSize: '30px',
  '@media (max-width: 768px)': {
    fontSize: '26px',
  },
  '@media (max-width: 480px)': {
    fontSize: '22px',
  },
});

const tooltip = css({
  position: 'absolute',
  top: '-60px',
  right: '0',
  backgroundColor: 'rgba(0, 0, 0, 0.8)',
  color: 'white',
  padding: '8px 12px',
  borderRadius: '6px',
  fontSize: '14px',
  whiteSpace: 'nowrap',
  pointerEvents: 'none',
  animation: `${fadeIn} 0.3s`,
  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: '-8px',
    right: '24px',
    borderLeft: '8px solid transparent',
    borderRight: '8px solid transparent',
    borderTop: '8px solid rgba(0, 0, 0, 0.8)',
  },
  '@media (max-width: 480px)': {
    fontSize: '12px',
    right: '-50%',
    transform: 'translateX(50%)',
  },
});

export const WhatsAppButton: React.FC<WhatsAppButtonProps> = ({ className, ...rest }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5511947043137?text=Ol%C3%A1%21%20Podem%20me%20ajudar%3F');
  };

  return (
    <div
      className={`${button} ${className || ''}`}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      onClick={handleWhatsAppClick}
      {...rest}
    >
      <FaWhatsapp className={icon} />
      {showTooltip && (
        <div className={tooltip}>Clique em mim para ser redirecionado ao WhatsApp</div>
      )}
    </div>
  );
};

export default WhatsAppButton;
